import { Button, IconButton, Stack, Typography, useTheme } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import DeleteIcon from '@mui/icons-material/Delete'
import { useTranslation } from 'react-i18next'
import { fsColors } from '../../../../shared/constants'
import { EtlCharValueMapping, EtlValueMapping } from '../../../../shared/model/models'
import { useAppDispatch, useAppSelector } from '../../../../store/hooks'
import { addVariable, deleteCharVariable } from '../../../../store/actions'
import FsVariable from './FsVariable'

const FsVariableGroup = ({ mapping }: { mapping: EtlCharValueMapping }) => {
  const theme = useTheme()
  const dispatch = useAppDispatch()
  const { etlOriginalValues } = useAppSelector((state) => state.currentEtl)
  const { t } = useTranslation()

  const addNewGroupForm = () => {
    if (!mapping) {
      return
    }

    const variable: EtlValueMapping = {
      id: null,
      characteristic: mapping.id,
      label: `${mapping.name}_group`,
      originalValues: [],
    }

    dispatch(addVariable({ variable }))
  }

  const selectedValues = mapping?.mappings.flatMap((map) => map.originalValues).length
  const allValues =
    etlOriginalValues && mapping?.id && etlOriginalValues[mapping.id]
      ? etlOriginalValues[mapping.id]
      : []
  const totalValues = allValues.length

  return (
    <Stack
      borderRadius={2}
      p={2}
      gap={1}
      sx={{
        backgroundColor: theme.palette.action.disabledBackground,
      }}
    >
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Stack direction="row" alignItems="center" gap={1}>
          <Typography variant="h6">{mapping.name}</Typography>
          <Typography color={fsColors.fsGray.colors[1]}>
            ({selectedValues}/{totalValues}) Selected
          </Typography>
        </Stack>
        <Stack direction="row" justifyContent="flex-end">
          <Button
            startIcon={<AddIcon />}
            sx={{
              backgroundColor: fsColors.fsGray.colors[2],
              color: fsColors.fsGray.colors[0],
            }}
            onClick={addNewGroupForm}
          >
            {t('group.add')}
          </Button>
          <IconButton
            onClick={() => {
              if (mapping.id) dispatch(deleteCharVariable({ characteristicId: mapping.id }))
            }}
          >
            <DeleteIcon color="disabled" />
          </IconButton>
        </Stack>
      </Stack>
      {mapping?.mappings.map((map) => (
        <FsVariable
          mapping={map.id}
          key={`${mapping.id}_${map.id}`}
          containerId={mapping.id}
          etlOriginalValues={allValues}
        />
      ))}
    </Stack>
  )
}

export default FsVariableGroup
